import { ComponentStyleConfig } from '@chakra-ui/react';

const Badge: ComponentStyleConfig = {
  defaultProps: {
    variant: 'primary',
  },
  variants: {
    primary: {
      bg: 'content-bg',
      padding: '4px 10px',
      rounded: 'full',
    },
  },
};

export default Badge;
